import {Image, Text, TouchableOpacity, useWindowDimensions} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import strings from '../../../translations';
import {getSize} from 'helpers/getSize';
import {DEVICE_SIZES} from 'rn-responsive-styles';

interface SignInWithGoogleButtonProps {
  onPress(): void;
}

const SignInWithGoogleButton = (props: SignInWithGoogleButtonProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);
  const width = useWindowDimensions().width;

  return (
    <TouchableOpacity
      onPress={props.onPress}
      activeOpacity={0.8}
      style={styles.googleButtonStyle}>
      <Image
        style={styles.imageStyle}
        source={
          width > getSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)
            ? theme.images.googleIconBlue
            : theme.images.colorfulGoogleLogo
        }
      />

      <Text style={styles.googleButtonLabelStyle}>
        {strings.shared.signInGoogle}
      </Text>
    </TouchableOpacity>
  );
};

export default SignInWithGoogleButton;
